export default __webpack_public_path__ + "static/GreyWagtail-3a957dcb12482c93ac249c4aa4029cc5.jpeg";